import {Box, Grid, Tab, Tabs, Typography, Stack, useTheme, useMediaQuery, Paper} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useSelector} from "../../../../redux/store";
import {IHesap} from "../../../../constants/types/logbook";
import HesapDetay from "./HesapDetay";
import {AccountBalance, CreditCard, AccountBalanceWallet} from '@mui/icons-material';

const Hesaplar = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const sabitler = useSelector(state => state.app.sabitler);
    const hesaplar = (sabitler?.hesaplar || []).filter(x => ["İşletme", "Kredi", "Kredi Kartı"].includes(x.hesapTipi));

    const [hesapId, setHesapId] = useState<number>(0);

    useEffect(() => {
        if (hesapId === 0 && hesaplar.length > 0) {
            setHesapId(hesaplar[0].id);
        }
    }, [hesaplar, hesapId]);

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setHesapId(newValue);
    };

    const getIcon = (tip: string) => {
        if (tip === "Kredi Kartı") return <CreditCard sx={{ fontSize: 18 }} />;
        if (tip === "İşletme") return <AccountBalanceWallet sx={{ fontSize: 18 }} />;
        return <AccountBalance sx={{ fontSize: 18 }} />;
    };

    return (
        <Box sx={{ mt: 1 }}>
            <Paper sx={{
 
                p: 2, 
                mb: 3, 
                borderRadius: '16px', 
                border: '1px solid rgba(0,0,0,0.05)', 
                boxShadow: '0 2px 12px rgba(0,0,0,0.04)' 
            }}>
                <Tabs
                    value={hesapId}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    sx={{
                        '& .MuiTab-root': { 
                            fontWeight: 700, 
                            minHeight: 48, 
                            textTransform: 'none',
                            borderRadius: '8px',
                            mx: 0.5,
                            transition: 'all 0.2s'
                        },
                        '& .Mui-selected': { bgcolor: 'primary.light', color: 'primary.main' },
                        '& .MuiTabs-indicator': { display: 'none' }
                    }}
                >
                    {hesaplar.map((hesap: IHesap) => (
                        <Tab 
                            key={hesap.id} 
                            label={hesap.hesapAdi} 
                            value={hesap.id}
                            icon={getIcon(hesap.hesapTipi)}
                            iconPosition="start"
                        />
                    ))}
                </Tabs>
            </Paper>

            <Box sx={{ mt: 2 }}>
                {hesapId > 0 && <HesapDetay hesapId={hesapId}/>}
            </Box>
        </Box>
    );
}

export default Hesaplar;